// extracted by mini-css-extract-plugin
module.exports = {"beianContainer":"styles_beianContainer__rk_jj"};